import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { FantasyGame } from './models/fantasy-game.model';

export interface FantasyGameState extends EntityState<FantasyGame> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'fantasy-game', idKey: 'GameId' })
export class FantasyGameStore extends EntityStore<FantasyGameState> {

  constructor() {
    super();
  }

}

